const getCharsAround = (chars, text, { start, end }) => {
  // const searchIndex = text.toLowerCase().indexOf(searchString.toLowerCase())
  const splitBack = start - chars / 2
  const splitForward = end + chars / 2

  let firstIndex = splitBack >= 0 ? splitBack : 0
  let lastIndex = splitForward <= text.length ? splitForward : text.length

  if (firstIndex === 0) {
    if (lastIndex < text.length) {
      lastIndex =
        lastIndex + -1 * splitBack > text.length ? text.length : lastIndex + -1 * splitBack
    }
  } else if (lastIndex > text.length) {
    firstIndex =
      firstIndex - (lastIndex - text.length) >= 0 ? firstIndex - (lastIndex - text.length) : 0
  }

  return (
    (firstIndex ? '... ' : '') +
    text.substring(firstIndex, lastIndex) +
    (lastIndex - text.length ? ' ...' : '')
  )
}

const isBlank = str => {
  return !str || /^\s*$/.test(str)
}

const capitalizeName = str => {
  const words = str.toLowerCase().split(" ")
  return words.map(word => word[0].toUpperCase() + word.substring(1)).join(" ")
}

const capitalizeTitle = title => {
  return title[0].toUpperCase() + title.substring(1).toLowerCase()
}

export { capitalizeName, capitalizeTitle, getCharsAround, isBlank }
